// extracted by mini-css-extract-plugin
export default {"iframeVideollamada":"ingresoVideollamada_iframeVideollamada__LJbMh","titulo":"ingresoVideollamada_titulo__w7L+o"};